module.exports = __webpack_public_path__ + "static/media/国家电网太原分公司高层宿舍集中供暖项目.8a8d5cc9.jpg";